module.exports = __webpack_public_path__ + "4e993e4a07ee2a4e06c78835691b0ee0.png";